import React from 'react';

const PhoneLink = ({phone}) => {
  const phoneLink = `tel:${phone}`;
  return <a href={phoneLink} className="phone-link" target='_blank' rel="noopener noreferrer">{phone}</a>;
}
export default PhoneLink;
